import request from '@/utils/request'

export function listMallCoupon(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.listMallCoupon',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => reject(error))
  })
}

export function saveMallCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.saveMallCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) resolve(res)
      else reject(res.msg || '保存失败')
    }).catch(error => reject(error))
  })
}

export function updateMallCoupon(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.updateMallCoupon',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) resolve(res)
      else reject(res.msg || '更新失败')
    }).catch(error => reject(error))
  })
}

export function updateMallCouponStatus(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.updateMallCouponStatus',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) resolve(res)
      else reject(res.msg || '操作失败')
    }).catch(error => reject(error))
  })
}

export function listMallCouponReceiveLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.listMallCouponReceiveLog',
      method: 'get',
      params
    }).then(response => resolve(response.data)).catch(error => reject(error))
  })
}

export function listMallCouponUseLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallCoupon.listMallCouponUseLog',
      method: 'get',
      params
    }).then(response => resolve(response.data)).catch(error => reject(error))
  })
}
